export interface SignupLookupI {
  region: string;
  gymName: string;
}
export interface SignupUserSearchI {
  emailAddress: string;
  email?: string;
  phoneNumber?: string;
}
